module.exports = ".editButton{cursor:pointer;vertical-align:text-bottom}tr td:last-child{vertical-align:middle}"